// Function to transfer the content of .realalt into the closest .theimage[data-alt]
function updateDataAltValues() {
    const realAltElements = document.querySelectorAll('.realalt');

    realAltElements.forEach(realAltElement => {
        // Find the closest .theimage element
        const closestImage = realAltElement.closest('.theimage');

        if (closestImage) {
            // Set the data-alt attribute of the closest .theimage to the content of the .realalt element
            closestImage.setAttribute('data-alt', realAltElement.textContent.trim());
        }
    });
}

// Function to handle changes in .variant_selector
function checkVariantOptions() {
    const variantSelector = document.querySelector('.variant_selector');
    if (!variantSelector) return;
    
    // Set a MutationObserver to listen for changes in the data-options attribute
    const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'data-options') {
                const currentOptions = mutation.target.getAttribute('data-options');
                /*console.log("Mutation detected, data-options changed to:", currentOptions); // Log current data-options*/

                // Perform action on the images based on data-options
                updateImagesBasedOnOptions(currentOptions);
            }
        });
    });

    // Start observing the variant selector for attribute changes
    observer.observe(variantSelector, {
        attributes: true // Listen for attribute changes only
    });

    // Also perform the action on page load
    const initialOptions = variantSelector.getAttribute('data-options');
    if (initialOptions) {
        /*console.log('Page load:', initialOptions); // Log initial data-options on page load*/
        updateImagesBasedOnOptions(initialOptions); // Perform initial update based on page load options
    }
}

// Function to show/hide images based on data-options
function updateImagesBasedOnOptions(options) {
    // Split the data-options into color and size, and trim them
    const [color, size] = options.split(',').map(option => option.trim()); 
    
    /*console.log("Selected color:", color);
    console.log("Selected size:", size);*/

    // Hide all images except the first one
    const allImages = document.querySelectorAll('.theimage');
    allImages.forEach((image, index) => {
        // Keep the first instance always visible
        if (index === 999) {
            image.style.display = 'block';
            return;
        }

        // Pull the alt value from data-alt attribute
        const altValue = image.getAttribute('data-alt');
       /* console.log(`Image alt: ${altValue}`);*/

        if (!altValue || altValue.trim() === '') {
            image.style.display = 'none'; // Hide images with empty data-alt values
            return;
        }

        // Split the data-alt into an array of colors for exact matching
        const altColors = altValue.split(',').map(color => color.trim());

        /*console.log(`Alt colors for this image: ${altColors}`);*/
        
        // Exact matching: If the selected color is NOT found in the altColors, hide the image
        if (!altColors.includes(color)) {
            image.style.display = 'none'; // Hide images that do not match the selected color
            /*console.log(`Hiding image with alt: ${altValue}`);*/
        } else {
            image.style.display = 'block'; // Show images that match the selected color
            /*console.log(`Showing image with alt: ${altValue}`);*/
        }
    });
}

// Initialize everything on page load
window.addEventListener('DOMContentLoaded', () => {
    updateDataAltValues(); // First, update data-alt values from .realalt
    checkVariantOptions(); // Then, set up the observer and run the initial image handling
});
